import { render, staticRenderFns } from "./LinkText.vue?vue&type=template&id=107940f6&scoped=true&"
import script from "./LinkText.vue?vue&type=script&lang=js&"
export * from "./LinkText.vue?vue&type=script&lang=js&"
import style0 from "./LinkText.vue?vue&type=style&index=0&id=107940f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107940f6",
  null
  
)

export default component.exports